@if (!showBankIdLoginWindow) {
  <div class="astral-auth-shell">
    <main class="astral-auth-panel">
      <header class="astral-auth-header">
        <div class="astral-auth-branding">
          <img src="assets/icons/hogia_logo.svg" alt="Hogia" />
          <span class="astral-auth-branding__divider" aria-hidden="true"></span>
          <span class="astral-auth-branding__name">DinHyresvärd</span>
          @if (envName) {
            <span class="astral-auth-branding__environment">{{ envName }}</span>
          }
        </div>
        <app-language class="astral-auth-language" [orientation]="2"></app-language>
      </header>

      <section class="astral-auth-content">
        @if (!restorePassword) {
          <astral-form
            class="astral-auth-form"
            [form]="loginForm"
            [columns]="1"
            [mobileColumns]="1"
            autocomplete="on"
            (formSubmit)="login()"
          >
            <h1 class="astral-auth-title">{{ 'LOGIN_TEXT' | translate }}</h1>

            <astral-tabs
              appearance="tinted"
              [tabs]="authMethods"
              [(selectedId)]="authMethod"
              ariaLabel="LOGIN_TEXT"
              panelId="login-auth-method-panel"
              tabIdPrefix="login-auth-method"
              [disabled]="loginForm.disabled"
            ></astral-tabs>

            <div
              id="login-auth-method-panel"
              class="astral-auth-form__full"
              role="tabpanel"
              [attr.aria-labelledby]="'login-auth-method-' + authMethod"
            >
              @if (authMethod === 'bankid') {
                <div class="astral-stack-m">
                <astral-button
                  class="astral-auth-action--wide"
                  type="button"
                  variant="primary"
                  [disabled]="loginForm.disabled"
                  labelKey="LOGIN_BANKID.LOGIN_WITH_BANKID"
                  (click)="toggleBankIdLoginWindow()"
                ></astral-button>
                @if (loginForm.disabled) {
                  <div class="spinner spinner--bankid" aria-hidden="true"><div></div><div></div><div></div><div></div></div>
                }
                </div>
              } @else {
                <astral-input
                [control]="loginControl"
                type="text"
                inputId="login-username"
                inputName="username"
                inputMode="email"
                autocomplete="username"
                [enableContactAction]="false"
                [showRequiredMarker]="false"
              ></astral-input>
                <astral-input
                [control]="passwordControl"
                type="password"
                inputName="password"
                autocomplete="current-password"
                [showRequiredMarker]="false"
              ></astral-input>

                <div class="astral-auth-support-row">
                @if (loginForm.disabled) {
                  <div class="spinner spinner--credentials" aria-hidden="true"><div></div><div></div><div></div><div></div></div>
                }
                <astral-checkbox
                  class="astral-auth-remember-me"
                  [control]="loginForm.controls['remember']"
                  inputName="remember"
                ></astral-checkbox>
                <astral-button
                  type="button"
                  variant="secondary"
                  size="small"
                  [disabled]="loginForm.disabled"
                  labelKey="LOGIN_FORM.FORGOT_PASSWORD_TEXT"
                  (click)="goRestore()"
                ></astral-button>
              </div>

                <div class="astral-form-actions astral-form-actions--start astral-auth-login-actions">
                <astral-button
                  class="astral-auth-action--wide"
                  type="submit"
                  variant="primary"
                  [disabled]="loginForm.disabled"
                  labelKey="LOGIN_TEXT"
                ></astral-button>
                </div>
              }
            </div>
          </astral-form>
        } @else {
          <div class="astral-stack-l">
            <div class="astral-form-actions astral-form-actions--start">
              <astral-button
                type="button"
                variant="secondary"
                size="small"
                icon="arrowLeft"
                labelKey="RESTORE_PASSWORD_FORM.GO_BACK_BTN"
                (click)="goBack()"
              ></astral-button>
            </div>

            @if (!isEmailSent) {
              <astral-form
                class="astral-auth-form"
                [form]="restoreForm"
                [columns]="1"
                [mobileColumns]="1"
                autocomplete="on"
                (formSubmit)="restore()"
              >
                <h1 class="astral-auth-title">{{ 'RESTORE_PASSWORD_FORM.HEADER' | translate }}</h1>
                <astral-input
                  [control]="restoreControl"
                  type="email"
                  inputName="email"
                  inputMode="email"
                  autocomplete="email"
                  [enableContactAction]="false"
                ></astral-input>
                <div class="astral-form-actions astral-form-actions--start">
                  <astral-button type="submit" variant="primary" labelKey="RESTORE_PASSWORD_FORM.SEND_BTN"></astral-button>
                </div>
              </astral-form>
            } @else {
              <section id="restore-sent" class="astral-auth-notice" aria-live="polite">
                <h2 class="astral-section-heading">
                  {{ 'RESTORE_PASSWORD_FORM.EMAIL_SENT_CAPTION' | translate: { email: restoreEmail } }}
                </h2>
                <p>{{ 'RESTORE_PASSWORD_FORM.EMAIL_SENT_TEXT' | translate }}</p>
              </section>
            }
          </div>
        }
      </section>
    </main>
  </div>
} @else {
  <div class="astral-auth-standalone">
    <header class="astral-auth-header">
      <div class="astral-auth-branding">
        <img src="assets/icons/hogia_logo.svg" alt="Hogia" />
        <span class="astral-auth-branding__divider" aria-hidden="true"></span>
        <span class="astral-auth-branding__name">DinHyresvärd</span>
      </div>
      <app-language class="astral-auth-language" [orientation]="2"></app-language>
    </header>

    <main class="bankid-login-wrapper" #bankIdContainer>
      <h1 class="title title--bankid">
        <img src="assets/image/bankId.svg" alt="" />
        {{ 'LOGIN_BANKID.LOGIN_WITH_BANKID' | translate }}
      </h1>

      @if (running) {
        <app-bankid-auth (requestFullscreen)="onRequestFullscreen()" [isAutoStart]="isAutoStart" (result)="onResult($event)" />
        <div class="exit-fullscreen">
          <astral-button
            class="exit-fullscreen__button"
            type="button"
            variant="secondary"
            icon="clear"
            labelKey="COMMON.EXIT_FULLSCREEN"
            (click)="onRequestFullscreen()"
          ></astral-button>
        </div>
        <div class="cancel-container">
          <astral-button type="button" variant="secondary" labelKey="CANCEL_BTN" (click)="stopRunning()"></astral-button>
        </div>
      } @else {
        <div class="bankid-login-prompt">
          <div class="bankid-button-wrapper" [class.mobile-device-prompt]="isMobile">
            <astral-button
              class="astral-auth-action--wide"
              type="button"
              [variant]="isMobile ? 'secondary' : 'primary'"
              [disabled]="loginForm.disabled"
              labelKey="LOGIN_FORM.START_BANKID_OTHER_DEVICE"
              (click)="startBankId(false)"
            ></astral-button>
            <astral-button
              class="astral-auth-action--wide"
              type="button"
              [variant]="isMobile ? 'primary' : 'secondary'"
              [disabled]="loginForm.disabled"
              labelKey="LOGIN_FORM.START_BANKID"
              (click)="startBankId(true)"
            ></astral-button>
          </div>
          <astral-button
            class="return-button"
            type="button"
            variant="secondary"
            icon="arrowLeft"
            labelKey="LOGIN_RETURN_TO_FORM"
            (click)="toggleBankIdLoginWindow()"
          ></astral-button>
        </div>
      }
    </main>
  </div>
}
